import { css } from "@lit/reactive-element";
export const sidenavContainerStyles = css `
	:host {
		display: flex;
	}
`;
